import React, { Component, Fragment } from "react";
import "../../styles/Popup.module.css";
import { Form, Select, Input } from "antd";
import { connect } from "react-redux";
import { requestServerGet, requestServerPost, selectPage } from "../../actions";
import PopupManager from "../../managers/PopupManager";
import DataHelper from "../../helpers/DataHelper";
import { ListMusic } from "lucide-react";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

const { Option } = Select;

const formItemLayout = {
  labelCol: { span: 0 },
  wrapperCol: { span: 24 },
};

class CreatePlaylistPage extends Component {
  constructor(props) {
    super(props);
    this.state = { fileList: [], branches: [], lastSelectedBranches: [] };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    const {
      selectedBrandData,
      selectedBranchData,
      data: playlistData,
    } = this.props;
    const sharingMode = selectedBrandData
      ? selectedBrandData.ContentSharingMode
      : null;
    const isBrandLevel = !selectedBranchData;
    if ((sharingMode == 2 || sharingMode == "2") && isBrandLevel) {
      DataHelper.getBranches(
        { brandid: selectedBrandData.BrandID },
        this.props,
      ).then((branchList) => {
        this.setState({ branches: branchList || [] });
      });
    }

    let initialAccessBranches = ["all"];
    if (playlistData && playlistData.AccessBranches) {
      const acc = playlistData.AccessBranches;
      if (acc !== "all" && acc !== "null" && acc !== "") {
        initialAccessBranches = String(acc)
          .split(",")
          .map((s) => s.trim());
      }
    }
    this.setState({ lastSelectedBranches: initialAccessBranches });
  }

  handleBranchChange = (value) => {
    let newValues = [...value];
    if (
      newValues.includes("all") &&
      !this.state.lastSelectedBranches?.includes("all")
    ) {
      newValues = ["all"];
    } else if (newValues.includes("all") && newValues.length > 1) {
      newValues = newValues.filter((v) => v !== "all");
    } else if (newValues.length === 0) {
      newValues = ["all"];
    }

    this.setState({ lastSelectedBranches: newValues });
    this.formRef.current.setFieldsValue({ accessbranches: newValues });
  };

  normFile = (e) => {
    // console.log('Upload event:', e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  onChange = ({ fileList: newFileList }) => {
    // console.log("onChange " + JSON.stringify(newFileList))
    this.setState({ fileList: newFileList });
  };

  onPreviewDrop = (files) => {
    this.setState({
      files: this.state.fileList.concat(files),
    });
  };

  onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };

  onFinish = (values) => {
    const {
      requestServerPost,
      usertoken,
      selectedBrandData,
      selectedBranchData,
      data = null,
      onPlaylistCreated = () => {},
    } = this.props;

    // Determine create level and accessbranches based on ContentSharingMode
    const sharingMode = selectedBrandData
      ? selectedBrandData.ContentSharingMode
      : null;
    const isSharingMode2 = sharingMode == 2 || sharingMode == "2";
    let createlevel = 1;
    let accessbranches = "all";

    if (isSharingMode2) {
      const isBrandLevel = !selectedBranchData;
      createlevel = isBrandLevel ? 1 : 2;
      if (isBrandLevel) {
        const selected = values.accessbranches;
        if (!selected || selected.length === 0 || selected.includes("all")) {
          accessbranches = "all";
        } else {
          accessbranches = selected.map((s) => String(s)).join(",");
        }
      } else {
        accessbranches = String(selectedBranchData.BranchID);
      }
    }

    // Use plain object (not FormData) so normalizeParams does not run restoreType,
    // which would incorrectly coerce numeric-string branch IDs to numbers.
    if (data) {
      const params = {
        playlistid: data.PlaylistID,
        playlistname: values.playlistname,
        createlevel,
        accessbranches,
      };
      requestServerPost(
        "update_playlist",
        params,
        {},
        (response) => {
          PopupManager.closePopup();
        },
        usertoken,
      );
    } else {
      const params = {
        brandid: selectedBrandData.BrandID,
        playlistname: values.playlistname,
        createlevel,
        accessbranches,
      };
      requestServerPost(
        "create_playlist",
        params,
        {},
        (response) => {
          onPlaylistCreated(response.data.playlistid);
          PopupManager.closePopup();
        },
        usertoken,
      );
    }
  };

  render() {
    const {
      requestServerPost,
      usertoken,
      selectedBrandData,
      selectedBranchData,
      data = null,
      langT,
    } = this.props;
    const t = langT || {
      editTitle: "Edit Playlist",
      createTitle: "Create a New Playlist",
      editSub: (name) => `Editing "${name}"`,
      createSub: "Name your playlist and set branch access",
      playlistNameLabel: "Playlist Name",
      playlistNamePlaceholder: "e.g. Morning Lobby Loop",
      playlistNameRequired: "Please enter a playlist name",
      branchAccessLabel: "Branch Access",
      branchAccessPlaceholder: "Select branches",
      branchAccessRequired: "Please select branch access",
      allBranches: "All Branches",
      saveChanges: "Save Changes",
      createBtn: "Create Playlist",
    };
    const sharingMode = selectedBrandData
      ? selectedBrandData.ContentSharingMode
      : null;
    const isBrandLevel = !selectedBranchData;
    const showBranchSelector =
      (sharingMode == 2 || sharingMode == "2") && isBrandLevel;

    let initialAccessBranches = ["all"];
    if (data && data.AccessBranches) {
      const acc = data.AccessBranches;
      if (acc !== "all" && acc !== "null" && acc !== "") {
        initialAccessBranches = String(acc)
          .split(",")
          .map((s) => s.trim());
      }
    }

    const previewStyle = {
      display: "inline",
      width: 100,
      height: 100,
    };
    const bleed = { margin: -24, overflow: "hidden" };
    const body = { maxWidth: 440, margin: "0 auto", padding: "32px 40px" };

    return (
      <div style={{ ...bleed }}>
        <div
          style={{
            background: "linear-gradient(135deg,#6366f1 0%,#4f46e5 100%)",
            padding: "36px 40px",
            textAlign: "center",
            color: "#fff",
          }}
        >
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: 16,
              background: "rgba(255,255,255,0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 14px",
            }}
          >
            <ListMusic size={28} color="#fff" />
          </div>
          <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 6 }}>
            {data ? t.editTitle : t.createTitle}
          </div>
          <div style={{ fontSize: 14, color: "rgba(255,255,255,0.75)" }}>
            {data ? t.editSub(data.PlaylistName) : t.createSub}
          </div>
        </div>
        <div style={{ ...body }}>
          <Form
            name="create_playlist_form"
            {...formItemLayout}
            ref={this.formRef}
            onFinish={this.onFinish}
            initialValues={{
              playlistname: data ? data.PlaylistName : "",
              accessbranches: initialAccessBranches,
            }}
          >
            <div style={{ marginBottom: 20 }}>
              <label
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#64748b",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  display: "block",
                  marginBottom: 6,
                }}
              >
                {t.playlistNameLabel}
              </label>
              <Form.Item
                name="playlistname"
                style={{ marginBottom: 0 }}
                rules={[{ required: true, message: t.playlistNameRequired }]}
              >
                <Input
                  size="large"
                  placeholder={t.playlistNamePlaceholder}
                  style={{ borderRadius: 10 }}
                  autoFocus
                />
              </Form.Item>
            </div>
            {showBranchSelector && (
              <div style={{ marginBottom: 20 }}>
                <label
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: "#64748b",
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                    display: "block",
                    marginBottom: 6,
                  }}
                >
                  {t.branchAccessLabel}
                </label>
                <Form.Item
                  name="accessbranches"
                  style={{ marginBottom: 0 }}
                  rules={[{ required: true, message: t.branchAccessRequired }]}
                >
                  <Select
                    mode="multiple"
                    allowClear
                    placeholder={t.branchAccessPlaceholder}
                    onChange={this.handleBranchChange}
                    size="large"
                    style={{ width: "100%", borderRadius: 10 }}
                  >
                    <Option key="all" value="all">
                      {t.allBranches}
                    </Option>
                    {this.state.branches.map((b) => (
                      <Option key={b.BranchID} value={String(b.BranchID)}>
                        {b.BranchName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            )}
            <Form.Item style={{ marginBottom: 0, marginTop: 8 }}>
              <button
                type="submit"
                style={{
                  width: "100%",
                  height: 48,
                  borderRadius: 10,
                  border: "none",
                  background: "linear-gradient(135deg,#6366f1,#4f46e5)",
                  color: "#fff",
                  fontSize: 15,
                  fontWeight: 600,
                  cursor: "pointer",
                  boxShadow: "0 2px 10px rgba(99,102,241,0.3)",
                }}
              >
                {data ? t.saveChanges : t.createBtn}
              </button>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
}

const Styles = {};

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    selectedBrandData: state.selectedBrandData,
    selectedBranchData: state.selectedBranchData,
  };
};

const ConnectedCreatePlaylistPage = connect(mapStateToProps, {
  requestServerPost,
  requestServerGet,
  selectPage,
})(CreatePlaylistPage);

const CreatePlaylistPageWithLang = (props) => {
  const { lang } = useProLanguage();
  const langT = PRO_TRANSLATIONS[lang].createPlaylist;
  return <ConnectedCreatePlaylistPage {...props} langT={langT} />;
};

export default CreatePlaylistPageWithLang;
